import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Path } from '../../utils/constant/paths';
import { environment } from '../../../environments/environment';
import { HttpService } from 'src/app/services/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class PatientRegistrationService {
  constructor(private http: HttpService) {}

  checkMdUuid(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.CHECK_MD, {
      queryStringParameters: data
    });
  }

  searchPatient(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.GET, {
      queryStringParameters: data
    });
  }

  savePatient(data?: any) {
    return this.http.public_post(Path.PATIENT_REGISTRATION.POST, {
      body: data
    });
  }

  addCoupon(data?: any) {
    return this.http.public_post(Path.PATIENT_REGISTRATION.ADD_COUPON, {
      body: data
    });
  }

  listCoupons(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.ADD_COUPON, {
      queryStringParameters: data
    });
  }

  getTermsConditions(data?: any) {
    return this.http.public_get(
      Path.PATIENT_REGISTRATION.GET_TERMS_CONDITIONS,
      { queryStringParameters: data }
    );
  }

  getCampaignUrl(data?: any) {
    return this.http.public_get(Path.CUSTOMER_REGISTRATION.GET_CAMPAIGN_URL, {
      queryStringParameters: data
    });
  }

  getQrCode(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.GET_QR, {
      queryStringParameters: data
    });
  }

  downloadQrCode(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.DOWNLOAD_QR, {
      queryStringParameters: data
    });
  }

  listCampaigns(data?: any) {
    return this.http.public_get(Path.PATIENT_REGISTRATION.LIST_CAMPAIGNS, {
      queryStringParameters: data
    });
  }

  generateCoupon(data?: any) {
    return this.http.public_post(Path.PATIENT_REGISTRATION.GENERATE_COUPON, {
      body: data
    });
  }

  getQrCodes(data?: any) {
    return this.http.public_post(Path.PATIENT_REGISTRATION.GET_QRS, {
      body: data
    });
  }

  isCouponExpired(coupon): boolean {
    if (!coupon || !coupon.expiry_date) {
      if (environment.showLogs) {
        console.error('Coupon or expiry date is missing.');
      }
      return true;
    }

    const now = moment(); // Get the current date and time
    const expiryDate = moment(coupon.expiry_date); // Parse the expiry date

    // Check if the current date is after the expiry date
    return now.isAfter(expiryDate);
  }

  // remove country code to the mobile number
  formatPhoneNumber(phoneNumber: string): string {
    return phoneNumber.substring(3, phoneNumber.length);
  }

  getConsents(data: { schema_code: string }) {
    return this.http.public_get(Path.CONSENT.LIST, {
      queryStringParameters: data
    });
  }

  deletePatient(data: { schema_code: string, registration_code: string, patient_id: string }) {
    return this.http.public_post(Path.PATIENT_REGISTRATION.DELETE_ACCOUNT, {
      body: { data: data }
    });
  }
}
